<!-- 图片浮动标题展示：图片+标题+链接 -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :to="'/jpgy/gyDetail/'+info.id" v-bind:style="{backgroundImage:'url('+info.photosBg+')'}" target="_blank">
    <div class="title">{{info.name.length>titleLength?(info.name.substring(0,titleLength)+'...'):info.name}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock16',
  props: {
    info: {
      type: Object,
      default: {}
    },
    titleLength:{
      type:Number,
      default:40
    },
    labelLength:{
      type:Number,
      default:80
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  float:left;
  position:relative;
  box-sizing:content-box;
  height:200px;
  width:100%;
  padding:0px 0px 0px 0px;
  margin-top:0px;
  border:1px solid #fff;
  background-color: #fff;
  background-size: 100% 200px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid #eee;
  box-shadow:0px 0px 0.5px 0px #eee;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block .info-block-a:hover > .label{
  color:var(--color6);
}

.info-block-a .title{
  position:absolute;
  bottom:0px;
  width:100%;
  padding-left:5px;
  font-size:12px;
  font-weight:500;
  color:#fff;
  line-height:30px;
  background:rgba(0,0,0,0.5);
}

.info-block-a .label{
  display:block;
  font-size:12px;
  padding-top:6px;
  color:#888888;
  line-height:20px;
}


.info-block-a .date{
  display:block;
  height:20px;
  padding-left:20px;
  position:absolute;
  bottom:15px;
  font-size:12px;
  color:#888888;
  line-height:20px;
  //background:red;
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock16.vue